/**
 * Asyncronously run Promises in an object { string_label: Promise, ... }
 * Returns the object, but with the results in place of their Promises.
 * 
 * @see https://github.com/chandru89new/js-cookbook/blob/main/parallel-promises.md
 * @param promises: Object{label:Promise}
 * @returns Object{label: result}
 */
export default async function (promises) {
  let promiseList = Object.entries(promises).map(async ([name, promise]) => {
    let res
    try {
      res = { data: await promise() }
    } catch (e) {
      res = { error: e }
    }
    return [name, res]
  })

  let intermediateResult = []

  for (let p of promiseList) {
    await intermediateResult.push(await p)
  }

  intermediateResult.forEach((result)=>{
    if(result[1].hasOwnProperty('data')){
      //assume axios and hoist data upward
      let hoistedData = result[1]?.data?.data
      if(hoistedData.hasOwnProperty('data')) {
        // still need to drill down another (for DAG, where 'data' is a property that's returned from the request)
        hoistedData = hoistedData.data
      }
      if(hoistedData) { result[1] = hoistedData }
    }
    console.log('outgoing result', result)
    return result
  })

  return Object.fromEntries(intermediateResult)
}